// extracted by mini-css-extract-plugin
export default {"container":"SidePanel_container__2YFA9","content":"SidePanel_content__AH6G1"};